module.exports = __webpack_public_path__ + "static/marnie0301-f2fb128142cfffc669c037a826d5bc84.jpg";